import baseRequest from '../baseRequest';
import AppConfig from '../../app/config/AppConfig';
import * as Actions from "../../redux/actions";
import {addPopup} from "../../redux/actions";
import * as popups from "../../constants/popup-types";

class UpdateUserDataSharingConsent extends baseRequest
{
    constructor(onSuccess, onFail) {
        super();
        this.name = 'UpdateUserDataSharingAndMarketingConsents';
        this.dispatch = null;
        this.response = null;
        this.config = new AppConfig();
        this.onFail = onFail
        this.onSuccessProp = onSuccess
    }

    //old call
    // execute(dispatch, payload) {
    //     this.dispatch = dispatch;
    //     this.call(this.config.api.requests.updateUserDataSharingConsent, payload);
    // }

    execute(dispatch, payload) {
        this.dispatch = dispatch;
        this.call(this.Config.api.requests.updateUserDataSharingAndMarketingConsent, payload, 'post', {
            //local
            // basePath: 'http://localhost:8083/relations/api/consents',
            //dev
            basePath: '//' + window.apiUrl + '/relations/api/consents',
            stringifyData: true,
        });
    }

    onSuccess() {
        super.onSuccess(this.response.data) //prints to console
        this.dispatch(Actions.getUserData());

        if(!this.response.data.isSuccess){
            return this.onFail()
        }
        this.onSuccessProp(this.response.data)
    }

    onFailure(response, methodName = '') {
        super.onFailure(response, methodName);

        this.onFail()
    }

    updateState(responseData) {

        // this.dispatch(Actions.setConsentsResponse(this.response.data));
        // this.dispatch(Actions.setNewsletterStatus(this.response.status === 1));
        // this.dispatch(Actions.setNewsletterSubscriptionResultText(this.response.data.result));
        // this.afterSuccess();
    }
}

export default UpdateUserDataSharingConsent;
